'use strict';

var Actions = require('../actions/StampServerActionCreators'),
    noop = require('../utils/noop'),
    getStampSegment = require('../utils/getStampSegment'),
    { del, get: get, post, put } = require('../utils/APIUtils');

var StampAPI = {
  postStamp(stamp) {
    post('/api/stamps', stamp, Actions.handlePostStamp, stamp.id);
  },

  updateStamp(stamp) {
    const stampSegment = getStampSegment(stamp);
    put(`/api/stamps/${stampSegment}`, stamp, Actions.handleUpdateStamp, stampSegment);
  },

  requestStamp(stampSegment) {
    get(`/api/stamps/${stampSegment}`, Actions.handleStamp, stampSegment);
  },

  deleteStamp(stampSegment) {
    del(`/api/stamps/${stampSegment}`, Actions.handleDeleteStamp, stampSegment);
  },

  likeStamp(stampSegment) {
    post(`/api/stamps/${stampSegment}/like`, Actions.handleLikeStamp, stampSegment);
  },

  unlikeStamp(stampSegment) {
    del(`/api/stamps/${stampSegment}/like`, Actions.handleUnlikeStamp, stampSegment);
  },

  incrementStampViews(stampSegment) {
    post(`/api/stamps/${stampSegment}/views`, noop);
  },

  requestFeedPage(url) {
    url = url || '/api/stamps/feed';
    get(url, Actions.handleFeedPage);
  },

  requestTrendingPage(url) {
    url = url || '/api/stamps/trending';
    get(url, Actions.handleTrendingPage);
  },

  requestUserLatestPage(userId, url) {
    url = url || `/api/users/${userId}/stamps/latest`;
    get(url, Actions.handleUserLatestPage, userId);
  },

  requestUserLikedPage(userId, url) {
    url = url || `/api/users/${userId}/stamps/likes`;
    get(url, Actions.handleUserLikedPage, userId);
  },

  requestZineLatestPage(zineSlug, url) {
    url = url || `/api/zines/${zineSlug}/stamps/latest`;
    get(url, Actions.handleZineLatestPage, zineSlug);
  },

  requestZinePendingPage(zineSlug, url) {
    url = url || `/api/zines/${zineSlug}/stamps/pending`;
    get(url, Actions.handleZinePendingPage, zineSlug);
  },

  requestStampLikePage(stampSegment, url) {
    url = url || `/api/stamps/${stampSegment}/likes`;
    get(url, Actions.handleStampLikePage, stampSegment);
  },

  requestSearchPage(terms, url) {
    url = url || `/api/stamps/search?q=${window.encodeURIComponent(terms)}`;
    get(url, Actions.handleSearchPage, terms);
  }
};

module.exports = StampAPI;


/** WEBPACK FOOTER **
 ** ./api/StampAPI.js
 **/